import React from 'react';
import './preloader.css';

export const Preloader: React.FC<{ fadeOut?: boolean }> = ({ fadeOut }) => {
  return (
    <div className={`preloader ${fadeOut ? 'fade-out' : ''}`}>
      <div className="progress-container">
        <div className="progress-bar" />
      </div>
      <p>Loading...</p>
    </div>
  );
};
